import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import BackgroundImage from './assets/cta-bg.png';
import BottomIllustration from './assets/cta-bottom.png';

import { CTAButton } from '@/src/domains/pricing/PricingOverviewSection';
import { tabletBreakpoint, fromDesktopBreakpoint } from '@/src/domains/shared/breakpoints';

const Title = styled.h1`
  ${({ theme }) => theme.typography.scale3};
  ${fluidProp('font-size', '32px', '48px')};
  font-weight: 500;
  color: var(--colors-blank);
  font-family: var(--typography-fontBossa);

  ${fromDesktopBreakpoint(css`
    margin: 150px auto 0;
  `)}
`;

const SectionWrapper = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '100px', '220px')};
  ${fluidProp(['padding-left', 'padding-right'], '16px', '48px')};
  text-align: center;
  background-image: url(${BackgroundImage.src});
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;

  ${fromDesktopBreakpoint(css`
    margin-top: -200px;
    padding-top: 140px;
  `)}
`;

const Container = styled(ContentContainer)`
  position: relative;
  z-index: 1;
`;

const IllustrationWrapper = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  bottom: -20px;
  z-index: 0;
  overflow: hidden;

  ${tabletBreakpoint(css`
    display: none;
  `)}
`;

const IllustrationLayerCover = styled.div`
  background-image: url(${BottomIllustration.src});
  background-repeat: repeat;
  background-position: center;
  padding: 100px 0;
`;

export const CtaButton = styled(CTAButton)`
  && {
    background-color: #f8f5ff;
    color: #00235c;
    margin-top: 50px;
  }
`;

export const PrimaryCTASection = ({
  title = 'Discover how Remote can make international hiring easier.',
  children,
}) => (
  <SectionWrapper>
    <Container>
      {fieldHasContent(title) && <Title>{title}</Title>}
      {children}
    </Container>
    <IllustrationWrapper>
      <IllustrationLayerCover />
    </IllustrationWrapper>
  </SectionWrapper>
);
